import { FilterField, labelId } from "kontrolEdge/helpers/advancedFilters";
import { LicensedInstance } from "./LicensedData";

export function makeLicensedFields(): FilterField<LicensedInstance>[] {
  const fields: FilterField<LicensedInstance>[] = [
    {
      label: "Name",
      key: "name",
      accessor: (r) => r.name,
      type: "string",
      inFreeText: true,
    },
    {
      label: "Description",
      key: "description",
      accessor: (r) => r.description,
      type: "string",
      inFreeText: true,
    },
    {
      label: "License",
      key: "license",
      accessor: (r) => r.license,
      type: "string",
      inFreeText: true,
    },
    {
      label: "ID",
      key: "id",
      accessor: (r) => r.id,
      type: "string",
      inFreeText: true,
    },
    {
      label: "High Availability",
      key: "highavailability",
      accessor: (r) => (r.cluster ? r.cluster.name : "Off"),
      type: "string",
      inFreeText: true,
    },
  ];

  // Ensure keys are set
  for (const f of fields) f.key ||= labelId(f.label);
  return fields;
}

